import React from 'react'
import cn from 'classnames'
import WithTooltip from 'components/shared/WithTooltip'
import styles from 'components/panels/stream-order.module.scss'
import { TopOrderPill } from './StreamOrder'
import type { TopOrderMeta, TopWindowKey } from './streamOrderMapping'
import { DISCOVER_BUTTONS, isDiscoverTop } from './radioArtistsModel'
import { setMusicPanelView, useMusicPanelView } from './musicPanelView'

// The Discover order row, in the shared stream-order look: New (newest songs),
// Hot (recent upvalue) and the stream's Top dropdown (Top New, Top 24h / Week / Month / Year, Top
// of all time). It sits in the Music header.
export default function DiscoverOrder({ panelId }: { panelId: string }) {
    const { discoverOrder, discoverWindow } = useMusicPanelView(panelId)
    const topNewEnabled = Boolean(window.gon?.currentUser?.can_top_new)
    const topMeta: TopOrderMeta = { standardOrder: 'upvalue', topNewEnabled }
    const isTop = isDiscoverTop(discoverOrder)

    const selectTop = (order: string, topWindow: TopWindowKey | null) =>
        setMusicPanelView(
            panelId,
            order === 'top_new'
                ? { discoverOrder: 'top_new', discoverWindow: null }
                : { discoverOrder: 'top', discoverWindow: topWindow },
        )

    return (
        <div className={styles.streamOrderComp}>
            <div className={styles.orderBtnContainer}>
                {DISCOVER_BUTTONS.map(option => (
                    <div key={option.key}>
                        <WithTooltip tip={option.tip}>
                            <button
                                type="button"
                                style={{ fontFamily: 'inherit', cursor: 'pointer' }}
                                aria-pressed={discoverOrder === option.key}
                                data-testid={`discover-order-${option.key}`}
                                className={cn(
                                    styles.orderBtn,
                                    discoverOrder === option.key && styles.selected,
                                )}
                                onClick={ev => {
                                    ev.stopPropagation()
                                    ev.preventDefault()
                                    setMusicPanelView(panelId, { discoverOrder: option.key })
                                }}
                            >
                                <i className={option.icon} />
                                <span className={styles.orderLabel}>{option.label}</span>
                            </button>
                        </WithTooltip>
                    </div>
                ))}
                <div data-testid="discover-order-top">
                    <TopOrderPill
                        meta={topMeta}
                        icon="fa fa-arrow-up fa-large"
                        fallbackLabel={topNewEnabled ? 'Top New' : 'Top'}
                        isSelected={isTop}
                        effectiveOrder={discoverOrder === 'top_new' ? 'top_new' : 'upvalue'}
                        effectiveWindow={discoverWindow || undefined}
                        onSelect={selectTop}
                    />
                </div>
            </div>
        </div>
    )
}
